<template>
  <MainNavbar class="edu-fixed-nav" />
  <PaymentPending />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import MainNavbar from "../components/Layouts/MainNavbar.vue";
import PaymentPending from "../components/Payment/PaymentPending.vue";

export default defineComponent({
  name: "PaymentPendingPage",
  components: {
    MainNavbar,
    PaymentPending,
  },
});
</script>
